import Vue from 'vue'
import Vuex from 'vuex'
import {
  removeToken
} from "../token";
import request from '../axios'

const getQueryString = function (name) {
  let match = undefined
  let href = window.location.href
  let index = href.indexOf('?')
  if (index > -1 && href.match(new RegExp(name, 'i'))) {
    let queryStr = href.slice(index + 1).replace(/#([^?]+)/g, '')
    let matches = queryStr.match(new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i'))
    match = matches && matches[2] ? decodeURIComponent(matches[2]) : undefined
  }
  return match
}

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    isLogIn: JSON.parse(localStorage.getItem("saasIsLogIn")) || false,
    isSomeBind: JSON.parse(localStorage.getItem("isSomeBind")) || false,
    submitFlag: false,
    selectBank: sessionStorage.getItem("selectBank") === "true",
    changeBank: sessionStorage.getItem("changeBank") === "true",
    cashBankCard:
      (sessionStorage.getItem("cashBankCard") &&
        JSON.parse(sessionStorage.getItem("cashBankCard"))) ||
      {},
    applyMax: +sessionStorage.getItem("applyMax") || 1000,
    applyMin: +sessionStorage.getItem("applyMin") || 100,
    applyStep: +sessionStorage.getItem("applyStep") || 100,
    cashMoney: sessionStorage.getItem("cashMoney") || 0.0,
    cashMerchantId: sessionStorage.getItem("cashMerchantId") || 0,
    isJump: false,
    myContract: false,
    activeCardDetail:
      (sessionStorage.getItem("activeCardDetail") &&
        JSON.parse(sessionStorage.getItem("activeCardDetail"))) ||
      {},
    showNeedBind: sessionStorage.getItem("showNeedBind") || false, //支付宝、银行卡都未绑定，需要绑定弹窗
    aliAccount: sessionStorage.getItem("aliAccount") || "", //支付宝账号
    merchantNo: sessionStorage.getItem("merchantNo") || "", //商户编号
    orderNo: sessionStorage.getItem("orderNo") || "", //合同编号
    customerNo: sessionStorage.getItem("customerNo") || "", //用户编号
    idCard: sessionStorage.getItem("idCard") || "", //身份id
    name: sessionStorage.getItem("name") || "",
    isCase: sessionStorage.getItem("isCase") || "", // 做缓存
    copyrightInfo: {},
    showAlipay: "",
    isSupportWxOpen: true,
    get alipayData() {
      let _temp = {};

      try {
        _temp = JSON.parse(sessionStorage.getItem("alipayData") || "{ }") || {};
      } catch (error) {
        // console.error(error)
        // todo
        _temp = {};
      }
      return _temp;
    },
    set alipayData(value) {
      let _value = this.alipayData;

      _value = value;
    }
  },
  getters: {},
  mutations: {
    SET_LOG_IN_STATIC: (state, statue) => {
      state.isLogIn = statue; //设置是否登录
      if (statue === false) {
        removeToken();
      }
      localStorage.setItem("saasIsLogIn", statue);
    },
    SET_SOME_BIND_STATIC: (state, statue) => {
      state.isSomeBind = statue; //设置是否登录
      localStorage.setItem("isSomeBind", statue);
    },
    TOGGLE_SUBMIT_FLAG: (state, statue) => {
      state.submitFlag = statue;
    },
    SET_ACTIVE_CARD_DETAIL: (state, value) => {
      state.activeCardDetail = value;
      sessionStorage.setItem("activeCardDetail", JSON.stringify(value));
    },
    SET_APPLY_MIN: (state, value) => {
      //预支最小金额
      state.applyMin = value;
      sessionStorage.setItem("applyMin", value);
    },
    SET_APPLY_MAX: (state, value) => {
      //预支最大金额
      state.applyMax = value;
      sessionStorage.setItem("applyMax", value);
    },
    SET_APPLY_STEP: (state, value) => {
      //预支步骤
      state.applyStep = value;
      sessionStorage.setItem("applyStep", value);
    },
    SET_CASH_MONEY: (state, value) => {
      //设置提现金额
      state.cashMoney = value;
      sessionStorage.setItem("cashMoney", value);
    },
    SET_CASH_MERCHANT_ID: (state, value) => {
      //设置商户Id
      state.cashMerchantId = value;
      sessionStorage.setItem("cashMerchantId", value);
    },
    SET_SHOW_NEED_BIND: (state, value) => {
      //设置都未绑定显示弹窗
      state.showNeedBind = value;
      value
        ? sessionStorage.setItem("showNeedBind", value)
        : sessionStorage.removeItem("showNeedBind");
    },
    SET_ALI_ACCOUNT: (state, value) => {
      state.aliAccount = value;
      sessionStorage.setItem("aliAccount", value);
    },
    SET_MERCHANT_NO: (state, value) => {
      //商户编号
      state.merchantNo = value;
      sessionStorage.setItem("merchantNo", value);
    },
    SET_ORDER_NO: (state, value) => {
      //合同编号
      state.orderNo = value;
      sessionStorage.setItem("orderNo", value);
    },
    SET_CUSTOMER_NO: (state, value) => {
      //用户编号
      state.customerNo = value;
      sessionStorage.setItem("customerNo", value);
    },
    SET_CARD_ID: (state, value) => {
      //身份ID
      state.idCard = value;
      sessionStorage.setItem("idCard", value);
    },
    SET_NAME: (state, value) => {
      //名字
      state.name = value;
      sessionStorage.setItem("name", value);
    },
    SET_CASE: (state, value) => {
      //名字
      state.isCase = value;
      sessionStorage.setItem("isCase", value);
    },
    SET_ALIPAY_SHOW: (state, value) => {
      //弹框
      state.showAlipay = value;
      sessionStorage.setItem("showAlipay", value);
    },
    SET_SUPPORT_WXOPEN: (state, value) => {
      state.isSupportWxOpen = value;
    },
    SET_ALIPAYDATA: (state, value = {}) => {
      state.alipayData = value;
      value
        ? sessionStorage.setItem("alipayData", JSON.stringify(value))
        : sessionStorage.removeItem("alipayData");
      // value ? sessionStorage.setItem('alipayData', value) : sessionStorage.removeItem('alipayData');
    }
  },
  actions: {
    getCopyrightInfo({ state }) {
      let _merchant = getQueryString("merchant") || "";

      return new Promise((resolve, reject) => {
        // if (Object.keys(state.copyrightInfo).length) {
        //   return resolve(state.copyrightInfo)
        // }
        request
          .post("/api/tab/bottomConfig", { merchantCode: _merchant })
          .then(res => {
            // console.log(res)
            state.copyrightInfo = res.results;
          });
      });
    }
  }
});
